import React from "react";
import { FiDownload } from "react-icons/fi";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "../../BaseUI/Modal";
import Button from "../../BaseUI/Button";

const PdfPreviewModal = ({
  isOpen,
  onClose,
  title,
  previewUrl,
  fileName,
  loading,
  error,
  onDownload,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    width="x-large"
    scrollBehavior="inside"
  >
    <ModalHeader>{title || "PDF Önizleme"}</ModalHeader>
    <ModalBody>
      {loading && (
        <div className="text-center text-muted py-5">PDF hazırlanıyor...</div>
      )}
      {!loading && error && (
        <div className="text-center text-danger py-5">{error}</div>
      )}
      {!loading && !error && previewUrl && (
        <div
          style={{
            height: "72vh",
            minHeight: 420,
            border: "1px solid #e2e8f0",
            borderRadius: 4,
            overflow: "hidden",
            background: "#f8fafc",
          }}
        >
          <iframe
            title={fileName || "PDF"}
            src={`${previewUrl}#toolbar=0&navpanes=0&view=FitH`}
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        </div>
      )}
    </ModalBody>
    <ModalFooter>
      <div className="d-flex gap-2">
        <Button
          appearance="primary-subtle"
          icon={<FiDownload />}
          onClick={onDownload}
          disabled={loading || !!error || !previewUrl}
        >
          İndir
        </Button>
        <Button appearance="danger-subtle" onClick={onClose}>
          Kapat
        </Button>
      </div>
    </ModalFooter>
  </Modal>
);

export default PdfPreviewModal;
